import {BaseContainerModel} from '../../base-container.model';

import {bl_wf_project_hdr_RowClass, bl_wf_project_hdr_RowInterface} from "../../../dbschema/bl_wf_project_hdr.model";
import {bl_wf_project_line_RowClass} from '../../../dbschema/bl_wf_project_line.model';
import {bl_wf_project_ext_RowClass} from '../../../dbschema/bl_wf_project_ext.model';

export class WfProjectContainerModel extends BaseContainerModel {
  bl_wf_project_hdr: bl_wf_project_hdr_RowInterface = new bl_wf_project_hdr_RowClass();
  bl_wf_project_lines: bl_wf_project_line_RowClass[] = [];
  bl_wf_project_exts: bl_wf_project_ext_RowClass[] = [];
}
